__turbopack_context__.v({
  "cardGrid": "styles-module-scss-module__PaqSUq__cardGrid",
  "gridContainer": "styles-module-scss-module__PaqSUq__gridContainer",
  "loadMoreSpinner": "styles-module-scss-module__PaqSUq__loadMoreSpinner",
  "loadMoreSpinnerBadge": "styles-module-scss-module__PaqSUq__loadMoreSpinnerBadge",
  "virtualGridOuter": "styles-module-scss-module__PaqSUq__virtualGridOuter",
  "virtualItemCell": "styles-module-scss-module__PaqSUq__virtualItemCell",
});
